import { useContext } from "react";

import { PlayerContext } from "../Player";

export default function usePlayer() {
  const context = useContext(PlayerContext);
  if (context === undefined) {
    throw new Error("You forgot to wrap your component in a Player");
  }
  return context;
}
